import Collection from '@arcgis/core/core/Collection';
import { NavigationLayer } from '../navigation.layer';
import { NavigationPseudoLayer } from './navigation.pseudo-layer';

export const getPseudoLayers = (parentLayer: NavigationLayer) =>
  new Collection<NavigationPseudoLayer>([
    new NavigationPseudoLayer({
      parentLayer,
      id: 'airport',
      label: 'Airports',
      visible: true,
      stylesRegex: {
        Low: ['Low/Airport/'],
        High: ['High/Airport/']
      },
      order: 1,
      themeSyncMode: 'parent' // Automatically sync with NavigationLayer's theme
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'airway',
      label: 'Airways',
      visible: true,
      stylesRegex: {
        Low: ['Low/Airway/'],
        High: ['High/Airway/']
      },
      order: 2,
      themeSyncMode: 'parent'
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'airspace',
      label: 'Airspaces',
      visible: true,
      stylesRegex: {
        Low: [],
        High: []
      },
      order: 3,
      themeSyncMode: 'parent',
      layers: [
        new NavigationPseudoLayer({
          parentLayer,
          id: 'fir',
          label: 'FIR/UIR',
          visible: true,
          stylesRegex: {
            Low: ['Low/Airspace/FIR'],
            High: ['High/Airspace/FIR']
          },
          order: 1,
          themeSyncMode: 'parent'
        }),
        new NavigationPseudoLayer({
          parentLayer,
          id: 'atc',
          label: 'ATC Sector',
          visible: true,
          stylesRegex: {
            Low: ['Low/Airspace/ATC'],
            High: ['High/Airspace/ATC']
          },
          order: 2,
          themeSyncMode: 'parent'
        }),
        new NavigationPseudoLayer({
          parentLayer,
          id: 'special',
          label: 'Special Use',
          visible: true,
          stylesRegex: {
            Low: ['Low/Airspace/Special'],
            High: ['High/Airspace/Special']
          },
          order: 3,
          themeSyncMode: 'parent'
        }),
        new NavigationPseudoLayer({
          parentLayer,
          id: 'terminal',
          label: 'Terminal',
          visible: true,
          stylesRegex: {
            Low: ['Low/Airspace/Terminal'],
            High: ['High/Airspace/Terminal']
          },
          order: 4,
          themeSyncMode: 'parent'
        }),
        new NavigationPseudoLayer({
          parentLayer,
          id: 'operational',
          label: 'Operational',
          visible: true,
          stylesRegex: {
            Low: ['Low/Airspace/Operational'],
            High: ['High/Airspace/Operational']
          },
          order: 5,
          themeSyncMode: 'parent'
        })
      ]
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'amdb',
      label: 'AMDB',
      visible: true,
      stylesRegex: {
        Low: ['Low/AMDB/'],
        High: ['High/AMDB/']
      },
      order: 4,
      themeSyncMode: 'parent'
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'navaid',
      label: 'Navaids',
      visible: true,
      stylesRegex: {
        Low: ['Low/Navaid/'],
        High: ['High/Navaid/']
      },
      order: 5,
      themeSyncMode: 'parent'
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'waypoint',
      label: 'Waypoints',
      visible: true,
      stylesRegex: {
        Low: ['Low/Waypoint/'],
        High: ['High/Waypoint/']
      },
      order: 6,
      themeSyncMode: 'parent'
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'latlon',
      label: 'LatLon Grid',
      visible: true,
      stylesRegex: {
        Low: ['Low/LatLon Grid'],
        High: ['High/LatLon Grid']
      },
      order: 7,
      themeSyncMode: 'parent'
    }),
    new NavigationPseudoLayer({
      parentLayer,
      id: 'grid_mora',
      label: 'Grid MORA',
      visible: true,
      stylesRegex: {
        Low: ['Low/Grid MORA'],
        High: ['High/Grid MORA']
      },
      order: 8,
      themeSyncMode: 'parent'
    })
  ]);
